import { FC } from 'react';
import Cookies from 'js-cookie';
import { AccessTokenPayload, AuthUser, IdTokenPayload, UserSession } from '~/libs/auth/types';
import { AppProps } from '~/pages/Auth/types';
import { CookieToken } from '.';

const ACCESS_TOKEN_COOKIE = 'testAccessToken';
const ID_TOKEN_COOKIE = 'testIdToken';
const USER_NAME = 'testUsername';

const withTestGuard = (AppComponent: FC<AppProps>) => {
  return function TestGuard() {
    const signOut = () => {
      Cookies.remove(ACCESS_TOKEN_COOKIE);
      Cookies.remove(ID_TOKEN_COOKIE);
      Cookies.remove(USER_NAME);
      window.location.href = `${import.meta.env.BASE_URL}logout`;
    };

    const user: AuthUser = {
      username: Cookies.get(USER_NAME) ?? 'developer_1',
      userId: Cookies.get(USER_NAME) ?? 'developer_1',
    };

    const userSession: UserSession = {
      accessToken: new CookieToken<AccessTokenPayload>(ACCESS_TOKEN_COOKIE),
      idToken: new CookieToken<IdTokenPayload>(ID_TOKEN_COOKIE),
      user: user,
      signOut: signOut,
    };

    return <AppComponent user={user} signOut={signOut} userSession={userSession} />;
  };
};

export default withTestGuard;
